// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"7538":"recorder","9983":"profiler"}[chunkId] || chunkId) + "." + {"1454":"7f5ef6d5b11b6f21","1850":"31d69d3a8f5d50dd","3621":"d42577ba390e2fa9","7538":"39a73edac99f2bd3","9983":"918fd3bc157cf281"}[chunkId] + ".js";
};